import { render, staticRenderFns } from "./stepsNav.vue?vue&type=template&id=65f05e2d&"
import script from "./stepsNav.vue?vue&type=script&lang=js&"
export * from "./stepsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/tabs/stepsNav.vue"
export default component.exports